// PersonRasterZone — German. The console's language; the record's own content stays French.
// 'not collected', 'Loading…', 'held', 'open' and 'none' live in common.de.ts and are not
// repeated. The evidence words, 'estimated', 'confidence', 'yes'/'no' and the two ProfileZone
// sentences this zone shares ARE declared below, byte-identical to ProfileZone.de.ts: this zone
// must read German on its own, and an identical duplicate never warns.
//
// The raster's own block, cell and token names are NOT in this file: they are declared beside
// their value in `src/shared/person-raster.v1.ts` and read through `personLabelFor`.
import { registerDe } from '../i18n/index.js';

registerDe({
  'Profile': 'Profil',
  'Fill': 'Ausfüllen',
  'Queuing…': 'Wird eingereiht…',
  '{n} comparable cells · {p} a fill may propose · raster {v}':
    '{n} vergleichbare Zellen · {p} darf ein Lauf vorschlagen · Raster {v}',
  'computed': 'berechnet',
  'not yet computed': 'noch nicht berechnet',
  'The night job has not computed this person yet; every computed cell reads "not collected" until it does.':
    'Der Nachtlauf hat diese Person noch nicht berechnet; jede berechnete Zelle liest bis dahin «nicht erhoben».',
  'five blocks of comparable cells — what the record can say about a person, and how it came to say it':
    'fünf Blöcke vergleichbarer Zellen — was der Bestand über eine Person sagen kann, und wie er dazu kam',
  'Send an agent to fill this raster: the employer’s own pages, the registers, your own correspondence — never LinkedIn. Every value arrives with its verbatim quote; what the rule can hold is held on arrival, the rest waits in Review.':
    'Einen Agenten dieses Raster füllen lassen: die eigenen Seiten des Arbeitgebers, die Register, Ihre eigene Korrespondenz — nie LinkedIn. Jeder Wert kommt mit seinem wörtlichen Zitat; was die Regel übernehmen kann, wird beim Eintreffen übernommen, der Rest wartet in der Prüfung.',

  // the states of the zone
  'The raster did not answer': 'Das Raster hat nicht geantwortet',
  'No cell of the raster is filled for this person. "Fill" starts a run; every value it reads comes back with its verbatim quote — a professional cell the rule can verify is held on arrival, everything about the person themselves waits for your click.':
    'Für diese Person ist keine Rasterzelle gefüllt. «Ausfüllen» startet einen Lauf; jeder gelesene Wert kommt mit seinem wörtlichen Zitat zurück — eine berufliche Zelle, die die Regel prüfen kann, wird beim Eintreffen übernommen, alles zur Person selbst wartet auf Ihren Klick.',
  'computed nightly · no claim mark': 'nächtlich berechnet · ohne Anspruchszeichen',

  // the coverage figures
  'held · estimated · computed · open — counted over the comparable cells asked of this person; a verdict and a cell that does not apply are counted apart':
    'übernommen · geschätzt · berechnet · offen — gezählt über die vergleichbaren Zellen, die dieser Person gestellt werden; ein Befund und eine nicht zutreffende Zelle werden gesondert gezählt',
  'estimated': 'geschätzt',

  // the states of a cell
  'not found': 'nicht gefunden',
  'A run searched for this cell and found nothing; later runs leave it alone unless asked to refresh.': 'Ein Lauf hat diese Zelle gesucht und nichts gefunden; spätere Läufe lassen sie in Ruhe, sofern nicht ausdrücklich nachgeforscht wird.',
  'not applicable': 'nicht zutreffend',
  'This cell is not asked of this person: the condition it hangs on — a register row, a rank, a held function — does not hold.':
    'Diese Zelle wird dieser Person nicht gestellt: die Bedingung, an der sie hängt — ein Registereintrag, eine Stufe, eine übernommene Funktion — trifft nicht zu.',
  '{n} proposal in Review': '{n} Vorschlag in der Prüfung',
  '{n} proposals in Review': '{n} Vorschläge in der Prüfung',
  'A proposal on this cell waits in Review; nothing is on the record until it is held.':
    'Ein Vorschlag zu dieser Zelle wartet in der Prüfung; nichts steht im Bestand, bis er übernommen ist.',
  'The agent inferred this value; it was not read off a page.':
    'Der Agent hat diesen Wert erschlossen; er wurde nicht von einer Seite abgelesen.',
  'confidence': 'Konfidenz',
  'read': 'Lesung',
  'declared': 'erklärt',
  'yes': 'ja',
  'no': 'nein',

  // the evidence
  'evidence': 'Beleg',
  'hide evidence': 'Beleg ausblenden',
  'Show the verbatim evidence for this cell': 'Den wörtlichen Beleg für diese Zelle zeigen',
  'The evidence names a source but keeps no verbatim passage.':
    'Der Beleg nennt eine Quelle, hält aber keine wörtliche Stelle fest.',
}, 'PersonRasterZone');
